
module.exports = {
  // TODO: change your profile information here
  name: "Vivek Sheth",
  greeting: "Hey 👋",
  greetingDescription: "I am skilled Software Engineer who loves to solve practical problems using technology",
  githubUrl: "https://github.com/vivekgsheth",
  linkedinUrl: "https://www.linkedin.com/in/vivek-sheth-487aaa157/",
  cvLink: "https://drive.google.com/file/d/1WGfFMEv9mlE--11QKr32lsBF2T9wMOVT/view?usp=sharing",
};
